import { useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import useApi from './useAPI';
import { USER_MANAGEMENT } from '../utils/const';
import { useContextValue } from '../context/LoaderContext';

let inFlightRefresh = null;

export const useUserDetailsRefresh = () => {
  const { userDetails, activePlan, setUserDetails, setActivePlan } = useContextValue();
  const { getData } = useApi();

  const refreshUserDetails = useCallback(async (showLoader = true) => {
    if (inFlightRefresh) {
      return inFlightRefresh;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      return null;
    }

    inFlightRefresh = (async () => {
      const decoded = jwtDecode(token);
      try {
        const response = await getData(
          USER_MANAGEMENT.GET_SINGLE_USER,
          decoded?.id,
          showLoader,
        );
        if (response?.status || response?.status === 200) {
          setUserDetails(response?.users?.user);
          setActivePlan(response?.users?.activePlan);
          return response?.users;
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
      return null;
    })();

    try {
      return await inFlightRefresh;
    } finally {
      inFlightRefresh = null;
    }
  }, [getData, setActivePlan, setUserDetails]);

  return {
    userDetails,
    activePlan,
    refreshUserDetails,
  };
};

export default useUserDetailsRefresh;
